// extracted by mini-css-extract-plugin
export default {"col":"applications_col__3l+Gr","holder":"applications_holder__oyFpd","applicationWrap":"applications_applicationWrap__PSEu5"};